import { render } from "./BpmOgpoTreatyStep.vue?vue&type=template&id=b8a9e3f0"
import script from "./BpmOgpoTreatyStep.vue?vue&type=script&lang=js"
export * from "./BpmOgpoTreatyStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__